export const calcScores = (scores) => {
    return +scores / 10
}

export function getParams() {
    const queryParams = {};
    const queryString = window.location.search.substring(1);
    const params = queryString.split('&');

    params.forEach(param => {
        const [key, value] = param.split('=');
        queryParams[key] = decodeURIComponent(value || '');
    });

    return queryParams;
}

export function getParam(key){
    return getParams()[key];
}

export const setStorage = (key, value) => {
    if(typeof value === "object" && value !== null){
        value = JSON.stringify(value)
    }
    localStorage.setItem(key, value);
}

export const getStorage = (key) => {
    return localStorage.getItem(key)
}

export const removeStorage = (key) => {
    localStorage.removeItem(key)
}

export const clearStorage = () => {
    localStorage.clear();
}

export const calcPrice = (price) => {
    return price / 100
}


export const isAndroid = () => {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    return isAndroid;
}

export const isIos = () => {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isiOS;
}


export function enterFullscreen(element) {
  // iOS Safari 特殊处理（只能对 video 元素调用）
  if (element.tagName === 'VIDEO' && element.webkitEnterFullscreen) {
    element.webkitEnterFullscreen();
    return;
  }

  // 标准 Fullscreen API
  const requestMethod = element.requestFullscreen ||
                        element.webkitRequestFullscreen ||
                        element.msRequestFullscreen ||
                        element.mozRequestFullScreen;

  if (requestMethod) {
    requestMethod.call(element);
  } else {
    console.warn('当前浏览器不支持全屏 API');
  }
}


/**
 * 监听全屏退出操作（包括按 ESC、调用 exitFullscreen、iOS 点击“完成”等）
 * @param {Function} onExit 退出全屏时的回调函数
 * @param {HTMLElement} [videoElement] iOS 需要传入 video 元素（可选，若未传则自动查找页面中的 video）
 * @returns {Function} 取消监听的函数
 */
export function onFullscreenExit(onExit, videoElement) {
  if (typeof onExit !== 'function') {
    throw new Error('onExit must be a function');
  }

  // 获取 video 元素（iOS 需要）
  let video = videoElement;
  if (!video && typeof document !== 'undefined') {
    video = document.querySelector('video');
  }

  // 判断是否为 iOS（仅用于决定是否添加 webkit 事件）
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  // 退出全屏的统一检测函数
  const checkExit = () => {
    const isFullscreen = !!(document.fullscreenElement ||
                            document.webkitFullscreenElement ||
                            document.mozFullScreenElement ||
                            document.msFullscreenElement);
    if (!isFullscreen) {
      onExit();
    }
  };

  // 标准 fullscreenchange 事件（兼容前缀）
  const events = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'];
  events.forEach(event => {
    document.addEventListener(event, checkExit);
  });

  // iOS 专用事件（仅在 video 存在且为 iOS 时添加）
  let iosHandler = null;
  if (isIOS && video && video.webkitEnterFullscreen) {
    iosHandler = () => {
      // iOS 退出全屏时不会触发 fullscreenchange，但会触发 webkitendfullscreen
      onExit();
    };
    video.addEventListener('webkitendfullscreen', iosHandler);
  }

  // 返回取消监听的函数
  return function off() {
    events.forEach(event => {
      document.removeEventListener(event, checkExit);
    });
    if (iosHandler && video) {
      video.removeEventListener('webkitendfullscreen', iosHandler);
    }
  };
}
